import React, { useCallback, useEffect, useState } from "react";
import FlusterButton from "../components/FlusterButton";
import FlusterTimeButton from "../components/FlusterTimerButton";
import FlusterVoteCard from "../components/FlusterVoteCard";
import _ from "lodash";
import Socket from "socket";
import FlusterVote from "../components/FlusterVote";
import { motion } from "framer-motion/dist/framer-motion";
import { divVariants, fadeVariants } from "shared/components/animations";
const FLUSFlusterQuestion = ({
  roomId,
  currentPlayerId,

  isAskerPlayer,

  currentPlayerVote,
  timer
}) => {
  const [votePoint, setVotePoint] = useState(1);
  const [countDown, setCountDown] = useState(timer);

  const handleVotePoint = (value) => {
    setVotePoint(value);
  };
  const voteButtonClickAction = () => {
    if (!isAskerPlayer) {
      const data = {
        action: "vote-flus",
        roomId,
        playerId: currentPlayerId,
        points: votePoint
      };
      Socket.sendMessage(data);
    }
  };
  const handleVoteButtonClick = useCallback(
    _.debounce(() => voteButtonClickAction(), 1000, {
      leading: true,
      trailing: false
    }),
    [votePoint]
  );
  useEffect(() => {
    const interval = setInterval(() => {
      if (countDown > 0) {
        setCountDown((prevCountDown) => prevCountDown - 1);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [countDown]);
  const formattedMinutes = String(Math.floor(countDown / 60)).padStart(2, "0");
  const formattedSeconds = String(countDown % 60).padStart(2, "0");
  const formattedTime = `${formattedMinutes}:${formattedSeconds}`;
  return (
    <motion.div
      variants={divVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="fluster-question"
    >
      {isAskerPlayer ? (
        <div className="flus-asker-screen">
          <motion.p variants={fadeVariants} className="text">
            A Fluster Card was Played.
          </motion.p>
          <FlusterTimeButton time={formattedTime} />
        </div>
      ) : (
        <>
          {!_.isEmpty(currentPlayerVote) ? (
            <FlusterVote
              votePoint={currentPlayerVote?.points}
              description={"You voted!"}
            />
          ) : (
            <div className="vote-screen">
              <FlusterVoteCard onClick={handleVotePoint} />
              <FlusterTimeButton time={formattedTime} />
              <FlusterButton text={"VOTE"} onClick={handleVoteButtonClick} />
            </div>
          )}
        </>
      )}
    </motion.div>
  );
};

export default FLUSFlusterQuestion;
